module.exports = __webpack_public_path__ + "static/media/dz.4be984a3.svg";